// "Everyday portions" setting (mobile: NutritionUnitPreferenceService). Sent as
// unit_style with every meal estimate so the server picks "1 tabak" style
// units or grams/ml. Per browser, like the theme.
const KEY = 'gm-everyday-units';

export function everydayUnitsEnabled() {
  try {
    return localStorage.getItem(KEY) !== 'off';
  } catch (e) {
    return true;
  }
}

export function setEverydayUnitsEnabled(on) {
  try {
    localStorage.setItem(KEY, on ? 'on' : 'off');
  } catch (e) {
    // storage blocked: the default (everyday) stays
  }
}

export const unitStyle = () => (everydayUnitsEnabled() ? 'everyday' : 'metric');
